
export enum ProductShelfPosition {
    'UNKNOWN',
    'REGULAR',
    'BASKET',
    'BOTTOM_SHELF',
    'HANGING',
    'TOP_SHELF'
}
